const dangerButtonClasses = 'tw:border-status-danger-solid tw:bg-transparent tw:text-foreground tw:hover:border-status-danger-solid tw:hover:bg-status-danger-surface'
const dangerSolidButtonClasses = 'tw:border-brand-red-600 tw:bg-brand-red-600 tw:text-foreground-inverse tw:hover:border-brand-red-700 tw:hover:bg-brand-red-700'
// Uses brand-red utilities rather than the `action` token so `.ds-page-hero` cannot rebind it to white.
const ctaButtonClasses = 'tw:border-brand-red-600 tw:bg-brand-red-600 tw:text-foreground-inverse tw:hover:border-brand-red-700 tw:hover:bg-brand-red-700'

export const buttonVariantClasses = {
  cta: ctaButtonClasses,
  danger: dangerButtonClasses,
  'danger-solid': dangerSolidButtonClasses,
  ghost: 'tw:border-transparent tw:bg-transparent tw:text-foreground-muted tw:hover:bg-surface-subtle tw:hover:text-foreground-strong',
  primary: 'tw:border-action tw:bg-action tw:text-action-foreground tw:hover:border-action-hover tw:hover:bg-action-hover',
  secondary: 'tw:border-strong tw:bg-surface tw:text-foreground tw:hover:border-focus tw:hover:bg-surface-muted',
}

export const heroButtonVariantClasses = {
  cta: ctaButtonClasses,
  danger: dangerButtonClasses,
  'danger-solid': dangerSolidButtonClasses,
  ghost: 'tw:border-transparent tw:bg-transparent tw:text-foreground-inverse tw:hover:bg-foreground-inverse/10',
  primary: 'tw:border-hero-action tw:bg-hero-action tw:text-hero-action-foreground tw:hover:border-hero-action-hover tw:hover:bg-hero-action-hover',
  secondary: 'tw:border-hero-control-border tw:bg-hero-control-background tw:text-hero-control-foreground tw:hover:border-hero-control-border-hover tw:hover:bg-hero-control-background-hover',
}

export const iconButtonVariantClasses = {
  danger: 'tw:border-transparent tw:text-brand-red-500 tw:hover:bg-status-danger-surface',
  ghost: 'tw:border-transparent tw:text-foreground-subtle tw:hover:bg-surface-subtle tw:hover:text-foreground-strong',
  success: 'tw:border-status-success-border tw:bg-status-success-surface tw:text-status-success-foreground tw:hover:bg-status-success-surface',
}

export const heroIconButtonVariantClasses = {
  ghost: 'tw:border-transparent tw:text-foreground-inverse/65 tw:hover:bg-foreground-inverse/10 tw:hover:text-foreground-inverse',
}

export const tableIconButtonVariantClasses = {
  danger: 'tw:border-transparent tw:bg-transparent tw:text-foreground-subtle tw:hover:bg-status-danger-surface tw:hover:text-brand-red-500 tw:focus-visible:bg-status-danger-surface tw:focus-visible:text-brand-red-500',
  ghost: 'tw:border-transparent tw:bg-transparent tw:text-foreground-subtle tw:hover:bg-surface-subtle tw:hover:text-foreground-strong tw:focus-visible:bg-surface-subtle tw:focus-visible:text-foreground-strong',
  success: 'tw:border-transparent tw:bg-transparent tw:text-foreground-subtle tw:hover:border-status-success-border tw:hover:bg-status-success-surface tw:hover:text-status-success-foreground tw:focus-visible:border-status-success-border tw:focus-visible:bg-status-success-surface tw:focus-visible:text-status-success-foreground',
}

export const buttonSizeClasses = {
  lg: 'tw:min-h-12 tw:px-6 tw:text-lg',
  md: 'tw:min-h-10 tw:px-4 tw:text-base',
  sm: 'tw:min-h-8 tw:px-3 tw:text-sm',
}
